import React, {Component} from 'react';
// Style
import './Modal.css';
import T from "i18n-react";
import FontIcon from "material-ui/FontIcon";
import ColorEnum from "../../enums/ColorEnum";

const DISPLAY_FIELDS = ["TRAN_NUMB", "ORDE_NUMB", "DATE", "AMOU", "BASEAMOUNT", "PAN", "ERRORCODE", "ERRORMESSAGE", "PAYM_TYPE", "CARD_ID", "PAYS", "BANK", "FLAG_3D_SECURE", "MERC_CONT_NUMB", "CONT_BANK", "PRIVATE_1", "PRIVATE_2", "PRIVATE_3", "PRIVATE_4", "PRIVATE_5"];

class ModalTransaction extends Component {

    displayValue = (transaction, value) => {
        if (transaction[value] === undefined || transaction[value] === null) {
            return T.translate('modalFields.missingData')
        }

        if (value === 'BASEAMOUNT' || value === 'AMOU') {
            return transaction[value].toPrice() + T.translate('currency.' + transaction['BASECURRENCY'])
        }

        if (value === 'DATE') {
            return transaction[value] + transaction['HOUR']
        }

        if (value === 'FLAG_3D_SECURE') {
            if (transaction[value] === "0") {
                return T.translate('common.no')
            } else {
                return T.translate('common.yes')
            }
        }

        return transaction[value]
    }

    render() {
        const {open, transaction, closeModal} = this.props;
        return (
            <div>
                {open ?
                    <div className="modal-transactions">
                        <div className="modal-background"/>
                        <div className="modal-window">
                            <div className="modal-body">
                                <div className="modal-close" onClick={closeModal}>
                                    <FontIcon className="material-icons" color="inherit">cancel</FontIcon>
                                </div>
                                <h1>{T.translate("transactionPage.details.title")} {transaction["TRAN_NUMB"]}</h1>
                                <div className="modal-table">
                                    {DISPLAY_FIELDS.map((value, index) => (
                                        <div key={index} className="modal-transactions-row" style={{ 'backgroundColor': index % 2 ? ColorEnum.WHITE : '#eeeeee' }}>
                                            <div>{T.translate('modalFields.'+value)} :</div>
                                            <div>
                                                {this.displayValue(transaction, value)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
            </div>
        );
    }
}

export default ModalTransaction;



// WEBPACK FOOTER //
// ./src/components/modal/ModalTransaction.js